import React from 'react';

import Menu from 'components/base/Menu/Menu';
import { Button, ListItem } from './shared/components';
import { IHasLabel } from 'types/shared';

interface IDropdownProps {
  items: IHasLabel[];
  selectedItem: any;
  disabled?: boolean;
  gtag?: string;
  overflowLeft?: boolean;
  onChange: (item: any) => void;
  onSelect?: (item: any) => void;
  itemToString?: (item: any) => string | false;
  isIconDisplayed?: boolean;
  isToggleCaret?: boolean;
  isActiveGreen?: boolean;
  minHeight?: string;
  isScrolled?: boolean;
  placeholder?: string;
  isRoundedDropdown?: string;
}

/**
 * This component composes `Menu` with Opus styles for the
 * commonly used basic dropdown.
 *
 * @param props.items objects with (for instance) labels and values
 * @param props.selectedItem currently active item
 * @param props.disabled disables the dropdown when true
 * @param props.overflowLeft overflows the dropdown to the left when true
 * @param props.gtag Override default gtag for dropdown ('dropdown')
 * @param props.placeholder Placeholder
 * @param props.isIconDisplayed
 */
const Dropdown: React.FC<IDropdownProps> = (props) => {
  const {
    items,
    selectedItem,
    onChange,
    onSelect,
    disabled,
    overflowLeft,
    gtag,
    itemToString,
    isIconDisplayed = false,
    isToggleCaret = false,
    isActiveGreen = true,
    minHeight,
    isScrolled,
    placeholder,
    isRoundedDropdown,
  } = props;

  return (
    <Menu
      items={items}
      selectedItem={selectedItem}
      disabled={disabled}
      Button={Button}
      Item={ListItem}
      overflowLeft={overflowLeft}
      gtag={gtag}
      onChange={onChange}
      onSelect={onSelect}
      itemToString={itemToString}
      isIconDisplayed={isIconDisplayed}
      isToggleCaret={isToggleCaret}
      isActiveGreen={isActiveGreen}
      minHeight={minHeight}
      isScrolled={isScrolled}
      placeholder={placeholder}
      isRoundedDropdown={isRoundedDropdown}
    />
  );
};

export default Dropdown;
